// extracted by mini-css-extract-plugin
export default {"ShowcaseSection":"ShowcaseSection_ShowcaseSection__q6lN9","line":"ShowcaseSection_line__CBg-K","icons":"ShowcaseSection_icons__Knjk4","icon":"ShowcaseSection_icon__k0bDT"};